module.exports = __webpack_public_path__ + "static/media/red-number-6.ebb11def.png";